import { createNextTableContext } from '@core/table';

export const CashRegisterOperationsTableContext = createNextTableContext();
